'use client'

import React from 'react'
import { useLocale, useTranslations } from 'next-intl'
import type { NormalizedCartItem } from '@/lib/booking-engine/types'
import type { Language } from '@/types/language.types'
import { cn } from '@/lib/utils'
import FirstLogo from '@/public/logo/f-logo.svg'

export function RateOfferBadges({
  item,
  className,
}: {
  item: Pick<NormalizedCartItem, 'isMember' | 'campaign'>
  className?: string
}) {
  const t = useTranslations()
  const locale = useLocale() as Language
  const badges = [
    ...(item.campaign
      ? [
          {
            id: 'campaign',
            title: item.campaign.title?.[locale] || item.campaign.title?.en || t('special_offer'),
          },
        ]
      : []),
    // ...(item.isMember ? [{ id: 'member', title: t('member_offer') }] : []),
  ]

  return (
    <>
      {badges.map((badge) => (
        <span
          key={badge.id}
          className={cn(
            'inline-flex min-h-5 max-w-full items-center gap-1.5 rounded bg-stone-800 px-2 text-xs font-medium',
            className,
          )}
        >
          <FirstLogo
            aria-hidden='true'
            focusable='false'
            className='h-3 w-auto shrink-0 [&_path]:fill-stone-50'
          />
          <span className='min-w-0 text-stone-50'>{badge.title}</span>
        </span>
      ))}
    </>
  )
}
